import { CanActivateViaAuthGuard } from './../bz-authentication/bz-can-activate-auth';
import { Routes } from '@angular/router';
import { UserGroupsComponent } from './user-groups/user-groups.component';
import { WorkingTimeSchemaComponent } from './working-time-schema/working-time-schema.component';
import {menus} from '../core/models/constants';

export const RoutesOrganization: Routes = [
    {
        path: menus.UserGroups.path,
        data: { title : menus.UserGroups.title },
        component : UserGroupsComponent,
        canActivate: [CanActivateViaAuthGuard]
    },
    {
        path: menus.WorkingTimeSchema.path,
        data: { title: menus.WorkingTimeSchema.title },
        component: WorkingTimeSchemaComponent,
        canActivate: [CanActivateViaAuthGuard]
    }
];
